import React, {useCallback, useEffect, useState} from 'react'

import { useDispatch, useSelector } from 'react-redux'

import {TextField, Button, Typography, Paper, Select, MenuItem, NativeSelect, InputLabel, OutlinedInput, FormControl, FormControlLabel, Checkbox, Grid, IconButton} from '@mui/material'

import useStyles from './styles.js'
import { createTeam, updateTeam } from '../../../actions/teams.js'
import { getCompetitions } from '../../../actions/competitions.js'
import DeleteIcon from '@mui/icons-material/Delete';
import { useTheme } from '@mui/styles'
import { discipline_all, getActualSeason, season_all, subscription_all } from '../../../bdd/bddSTUB.js'
import { getUserProvider, isAdminDSAS  } from '../../../actions/auth.js'
import SelectGroupProvider from '../../../dsasComponents/SelectGroupProvider.js'
import { useFetch } from '../../../filters/useFetch.js'
import { fetchCompetitions, fetchPlayerById } from '../../../api/index.js'
import { FETCH_ALL_COMPETITION } from '../../../constants/actionTypes.js'
import { fetchTeamById } from '../../../api/index.js'
import Select_Dsas from '../../../dsasComponents/Select_Dsas.js'

function getStyles(name, personName, theme) {
    return {
        fontWeight:
        personName.indexOf(name) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}

const intialForm = {
    name : '', 
    discipline : '', 
    logo : '', 
    color : '', 
    awayColor : '', 
    competitions : [], 
    isCountry : false, 
    competitionsPenality : [],

    stadiumName : '',
    stadiumCapacity : '',
    photoStadium : '',
    country : '', 
    teamCreation : '',
    website : '',
    president : '',
    coaches : '',

    subscription : 1,

    provider : getUserProvider()
}
const FormTeam = ({ currentId, setCurrentId }) => {
    const classes = useStyles();
    const theme = useTheme();

    const dispatch = useDispatch()

    const [teamData, setTeamData] = useState(intialForm)
    // FILTERS
    const [filters, setFilters] = useState({discipline : '', provider : teamData.provider, season : getActualSeason()})

    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)

    useEffect(() => {

        setFilters(s => ({...s, provider : teamData.provider}))

    }, [teamData.provider])


    useEffect(() => {
        if(currentId){
            // Effectuer requête API
            fetchTeamById(currentId)
            .then((response) => {
                setTeamData({...response.data[0]});
            })
            .catch((error) => {
            console.error(error);
            });
        }
    }, [currentId])

    const handleSubmit = (e) => {
        e.preventDefault()

        if(!teamData.discipline)
            return

        if(!teamData.stadiumCapacity)
            teamData.stadiumCapacity = 0

        // Refacto competitionsPenality
        teamData.competitionsPenality = teamData.competitionsPenality.map(t => ({competition : t.competition._id, penality : t.penality}))

        if(currentId){
            dispatch(updateTeam(currentId, teamData))
        }else{
            dispatch(createTeam(teamData))
        }

        clear()
    }

    const handleChange = (e) => {
        setTeamData(s => ({...s, [e.target.name]: e.target.value}))

        if(e.target.name === 'discipline'){
            setFilters(state => ({...state, discipline : e.target.value}))
        }
    }

    const handleChangeIsCountry = (event) => {
        setTeamData(s => ({...s, isCountry: event.target.checked}));
      };

    const handleSelect = (event) => {
        const {target: { value }} = event;

        // A la selection d'une competition pour l'équipe, on veut valoriser correctement le competitionsPenality
        let competitionsPenality = [...teamData.competitionsPenality]

        competitionsPenality = competitionsPenality.filter(t => value.includes(t.competition._id))
        
        value.forEach(competitionId => {
            let existingCompetition = competitionsPenality.find(t => t.competition._id === competitionId)
            if(!existingCompetition){
                competitionsPenality.push({competition : competitions.find(t => t._id === competitionId), penality : 0})
            }
        })

        setTeamData(s => ({...s, competitions: value, competitionsPenality}))
    };

    const handleSelectPenality = (competitionId, penality) => {
        let competitionsPenality = teamData.competitionsPenality.map(t => {
            if(t.competition._id === competitionId)
                return {...t, penality }
            
            return {...t}
        })

        setTeamData(s => ({...s, competitionsPenality}))
    }

    const handleDelete = (competitionId) => {
        // Implémentez ici la logique de suppression de la competition
        const competitionsPenality = teamData.competitionsPenality.filter(t => t.competition._id !== competitionId)
        const competitions = teamData.competitions.filter(t => t !== competitionId)

        setTeamData(s => ({...s, competitionsPenality, competitions}))
    };


    

    const clear = () => {
        setCurrentId(null)
        setTeamData(intialForm)
    }

    const handleSelectImage = (e) => {
        var file = e.target.files[0];
        setTeamData(s => ({...s, logo: file}))
    }

    const handleSelectStadeImage = (e) => {
        var file = e.target.files[0];
        setTeamData(s => ({...s, photoStadium: file}))
    }

    return (
        <Paper className={classes.paper} sx={{position : 'fixed', width : 300, maxHeight : 600, overflow : 'auto'}}>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
                <Typography variant="h6"> {currentId ? "Editer " : "Créer "} une équipe </Typography>

                {/*Discipline*/} 
                <FormControl sx={{ m: 1, width: 300 }} error={!teamData.discipline} >
                    <InputLabel id={"disciplinecompet"}>Discipline</InputLabel>
                    <Select 
                        labelId={'disciplinecompet'}
                        id={"disciplinecompetselect"}
                        name={'discipline'}
                        value={teamData.discipline}
                        label={'Discipline'}
                        onChange={handleChange}
                    >
                        {discipline_all && discipline_all.map(i => (<MenuItem key={i._id} value={i._id} selected >{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                <TextField 
                    name="name" 
                    variant="outlined"
                    label="Nom" 
                    fullWidth 
                    value={teamData.name || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="color" 
                    variant="outlined"
                    label="Couleur domicile" 
                    fullWidth 
                    value={teamData.color || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="awayColor" 
                    variant="outlined"
                    label="Couleur extérieur" 
                    fullWidth 
                    value={teamData.awayColor || ''}
                    onChange={handleChange}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                        checked={teamData.isCountry}
                        onChange={handleChangeIsCountry}
                        name="isCountry"
                        />
                    }
                    label="Equipe nationale"
                    />

                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                />



                <FormControl sx={{ m: 1, width: 300 }}>
                    <React.Fragment>
                    <InputLabel id="demo-multiple-name-label">Compétitions</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={teamData.competitions}
                        variant="outlined"
                        fullWidth 
                        onChange={handleSelect}
                        input={<OutlinedInput label="Equipes" />}
                        >
                        {competitions.map((compet) => (
                            <MenuItem
                            key={compet._id}
                            value={compet._id}
                            style={getStyles(compet._id, teamData.competitions, theme)}
                            >
                            {compet.name}
                            </MenuItem>
                        ))}
                    </Select>
                    </React.Fragment>
                </FormControl>

                <div>
                    {teamData.competitionsPenality.map((competitionInfo, idx) => (
                        <Grid container key={competitionInfo.competition._id} alignItems="center" sx={{background: idx % 2 === 0 ? 'lightgrey' : 'white'}}>
                            <Grid item xs={1}>
                                <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => handleDelete(competitionInfo.competition._id)}
                                >
                                <DeleteIcon fontSize="small"/>
                                </IconButton>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1">
                                    {`${competitionInfo.competition.name}`}
                                </Typography>
                            </Grid>
                            
                        <Grid item xs={7}>
                            <TextField
                                label='Penalité'
                                value={competitionInfo.penality}
                                onChange={(e) => handleSelectPenality(competitionInfo.competition._id, e.target.value)}
                            />
                        </Grid>
                        </Grid>
                    ))}
                </div>



                <TextField
                    name="upload-image"
                    type="file"
                    label='Logo'
                    value={''}
                    onChange={handleSelectImage}
                />

                <TextField 
                    name="stadiumName" 
                    variant="outlined"
                    label="Nom du stade" 
                    fullWidth 
                    value={teamData.stadiumName || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="stadiumCapacity" 
                    variant="outlined"
                    label="Capacité du stade" 
                    fullWidth 
                    value={teamData.stadiumCapacity || ''}
                    onChange={handleChange}
                />

                <TextField
                    name="upload-stadium-image"
                    type="file"
                    label='Photo du stade'
                    value={''}
                    onChange={handleSelectStadeImage}
                />

                <TextField 
                    name="country" 
                    variant="outlined"
                    label="Pays" 
                    fullWidth 
                    value={teamData.country || ''}
                    onChange={handleChange}
                /> 

                <TextField 
                    name="teamCreation" 
                    variant="outlined"
                    label="Année de création" 
                    fullWidth
                    value={teamData.teamCreation || ''}
                    onChange={handleChange}
                />  

                <TextField 
                    name="website" 
                    variant="outlined"
                    label="Site web" 
                    fullWidth
                    value={teamData.website || ''}
                    onChange={handleChange}
                /> 

                <TextField 
                    name="president" 
                    variant="outlined"
                    label="Président" 
                    fullWidth
                    value={teamData.president || ''}
                    onChange={handleChange}
                /> 

                <TextField 
                    name="coaches" 
                    variant="outlined"
                    label="Coaches (coach1/coach2/coach3...)" 
                    fullWidth
                    multiline
                    rows={3}
                    value={teamData.coaches || ''}
                    onChange={handleChange}
                /> 

                <TextField 
                    name="thirdPartyEntityId" 
                    variant="outlined"
                    label="Id externe" 
                    fullWidth
                    value={teamData.thirdPartyEntityId || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="thirdPartyId" 
                    variant="outlined"
                    label="Origine id externe" 
                    fullWidth
                    value={teamData.thirdPartyId || ''}
                    onChange={handleChange}
                />

                {/*Subscription*/} 
                <FormControl sx={{ m: 1, width: 300 }} >
                    <InputLabel id={"subscription"}>Type de direct</InputLabel>
                    <Select 
                        labelId={'subscription'}
                        id={"subscriptionselect"}
                        name={'subscription'}
                        value={teamData.subscription}
                        label={'Subscription'}
                        onChange={handleChange}
                    >
                        {subscription_all && subscription_all.map(i => (<MenuItem key={i._id} value={i._id} selected >{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                {isAdminDSAS() && <SelectGroupProvider value={teamData.provider} onChange={(e) => {
                    setTeamData(s => ({...s, provider : e.target.value}))
                    setFilters(f => ({...f, provider : e.target.value}))
                }}/>}

                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth> Valider </Button>
                <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth> Clear </Button>


            </form>

        </Paper>
    )
}

export default FormTeam